import React, { Component } from "react";
import ParamsService from "../services/params.service";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CaptchaService from "../services/captcha.service";
import ReCAPTCHA from "react-google-recaptcha";
import { withRouter } from '../common/with-router';
import AuthService from "../services/auth.service";
const KEY_CAPTCHA = process.env.REACT_APP_KEY_CAPTCHA;

const currentUser = AuthService.getCurrentUser();
const  token = ParamsService.$_GET("id");
const required = value => {
    if (!value) {
        return (
            <div className="alert alert-danger" role="alert">
                Champ obligatoire!
            </div>
        );
    }
};
class NewPassword extends Component {

    constructor(props) {
        super(props);
        this.onChangePwd = this.onChangePwd.bind(this);
        this.onChangePwd1 = this.onChangePwd1.bind(this);
        this.onChangePwd2 = this.onChangePwd2.bind(this);
        this.onChangeCaptcha = this.onChangeCaptcha.bind(this);

        this.state = {
            pwd: null,
            pwd1: "",
            pwd2: "",
            loading: false,
            KEY_CAPTCHA:KEY_CAPTCHA,
            cliccaptcha:false,
            resPwd:false,
            message:"",
            error:false
        };
    }
    onChangeCaptcha(value) {
        this.setState({loading:true})
        CaptchaService.validCaptchaChangePwd(value,this.state.pwd1,token==="changepwd" ? currentUser.userid : token,this.state.pwd).then(
            response => {
                this.setState({resPwd:false});
                if(response.data.success===true){
                    this.setState({cliccaptcha:true, loading:false});
                    this.setState({
                        message: "Votre mot de passe a bien été changé.",
                    });
                }else{
                    if(response.status===204){
                        this.setState({
                            message: "Merci de faire une autre demande pour changer votre mot de passe, le lien n'est pas actif.",
                            error:true,
                            loading:false,
                        });
                    }else {
                        if (response.status === 205) {
                            this.setState({
                                message: "Merci de vérifier votre mot de passe actuel.",
                                error: true,
                                loading: false,
                            });
                        } else {
                            this.setState({cliccaptcha: false, message: ""});
                        }
                    }
                }

            },
            error => {
                this.setState({resPwd:false});
                this.setState({cliccaptcha: false, error:true, loading:false});
                this.setState({
                    message: "Nous rencontrons actuellement un problème technique. Merci de réessayer ultérieurement."
                });
            }
        );


    }
    onChangePwd1(e) {
        this.setState({
            pwd1: e.target.value,
            message:"",
            error:false,
            cliccaptcha:false,
        });

        if(e.target.value===this.state.pwd2){
            this.setState({
               resPwd: true
            });
        }

    }

    onChangePwd(e) {
        this.setState({
            pwd: e.target.value,
            message:"",
            error:false,
            cliccaptcha:false
        });

    }

    onChangePwd2(e) {
        this.setState({
            pwd2: e.target.value,
            message:"",
            error:false,
            cliccaptcha:false,
        });

        if(e.target.value===this.state.pwd1){
            this.setState({
                resPwd: true
            });
        }else{
            this.setState({
                resPwd: false,
                error:true,
                message:"Merci de vérifier que les mots de passe saisis sont corrects."
            });
        }

    }

    render() {
        return (
            <div className="col-md-12">
                <div className="card card-container">
                    <img
                        src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
                        alt="profile-img"
                        className="profile-img-card"
                    />

                    <Form
                        ref={c => {
                            this.form = c;
                        }}
                    >
                        <div className="form-group">
                            {(token === "changepwd") &&
                                <div>
                            <label htmlFor="pwd">Saisir votre mot de passe actuel</label>
                            <Input
                                type="password"
                                className="form-control"
                                name="pwd"
                                value={this.state.pwd}
                                onChange={this.onChangePwd}
                                validations={[required]}
                            />
                                </div>
                                }

                            <label htmlFor="pwd1">Saisir votre nouveau mot de passe</label>
                            <Input
                                type="password"
                                className="form-control"
                                name="pwd1"
                                value={this.state.pwd1}
                                onChange={this.onChangePwd1}
                                validations={[required]}
                            />
                            <label htmlFor="pwd2">Saisir à nouveau votre nouveau mot de passe</label>
                            <Input
                                type="password"
                                className="form-control"
                                name="pwd2"
                                value={this.state.pwd2}
                                onChange={this.onChangePwd2}
                                validations={[required]}
                            />
                        </div>
                        {( this.state.resPwd && this.state.pwd1 && this.state.pwd2) && (
                            <div className="form-group">
                                <ReCAPTCHA
                                    sitekey={this.state.KEY_CAPTCHA}
                                    onChange={this.onChangeCaptcha}
                                    className="g-recaptcha"
                                />
                                {this.state.loading && (
                                    <span className="spinner-border spinner-border-sm"></span>
                                )}
                            </div>
                        )
                        }
                        {(this.state.message) && (
                            <div className="form-group">
                                <div className={!this.state.error ? "alert alert-success": "alert alert-danger"} role="alert">
                                    {this.state.message}
                                </div>
                                {token !== "changepwd" &&
                                    <a className="btn-ohm btn btn-primary btn-block" href="/login">
                                        <span>Login</span>
                                    </a>
                                }
                            </div>
                        )}

                    </Form>
                </div>
            </div>
        );
    }
}

export default withRouter(NewPassword);